// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { invoiceDetailSchema } from '@/billing/api/types';
import { serializeDateForAPI } from '@/utilities/date-time';
import { DateTime } from 'luxon';
import { z } from 'zod';

const addInvoiceResponseSchema = z.object({
  data: invoiceDetailSchema,
  metadata: responseMetadataSchema,
});

export interface AddInvoiceInput {
  customerKey: string;
  projectKey: string;
  invoiceDate: DateTime;
  dueDate: DateTime;
  paymentTerms: string | null;
  purchaseOrderNumber: string | null;
}

export async function addInvoice(input: AddInvoiceInput) {
  const url = `/v1/invoice`;
  const response = await api.post(url, {
    customerKey: input.customerKey,
    projectKey: input.projectKey,
    invoiceDate: serializeDateForAPI(input.invoiceDate),
    dueDate: serializeDateForAPI(input.dueDate),
    paymentTerms: input.paymentTerms,
    purchaseOrderNumber: input.purchaseOrderNumber,
  });

  const result = await parseResponse(addInvoiceResponseSchema, response.data, {
    schemaName: 'AddInvoice',
    endpoint: url,
  });
  return result.data;
}
